module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praise for articles and essays about the JFK and RFK assassinations written by Mel Ayton:")])]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("‘Mel Ayton’s research on this difficult question: “Who was responsible for the assassination of President John F. Kennedy?” is excellent.’ – Colonel Manuel Chavez, Former US Air Force Intelligence Officer assigned to the CIA’s office in Miami from 1960–4")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mel Ayton has a well-deserved reputation for doing the near-impossible: writing about controversial history (including conspiracy theories) in a sober but imaginative way, combining reliable accounts with intellectually stimulating arguments. I highly recommend his work’ – Rick Shenkman, publisher, History News Network")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘[Mel Ayton] is doing a fabulous job of setting history right’ – David Aaronovitch, columnist for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" and author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Voodoo Histories – The Role of the Conspiracy Theory in Shaping Modern History")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mel Ayton [is] one of the few analysts who has fully grasped the crime’s Middle East connection. . . . Far from being a “maniacally absurd” crime, as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Newsweek")]), _vm._v(" concluded, the Robert Kennedy assassination was in fact an eminently political act. It was the first “blowback” attack the United States suffered as a result of its Middle East policies’ – Stephen Kinzer, ‘Shot Heard Round the World’, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Guardian")]), _vm._v(", 13 June 2008")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The greatest riddle in any of these high-profile assassinations is motive. Thanks to Mel Ayton, the RFK killing can now be removed from that list of mysteries’ – Gus Russo, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Outfit and Supermob")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mel Ayton has accomplished something that no one writing about the RFK assassination has ever achieved before. By combining a judicious review of the forensic and eyewitness evidence with a firm grasp of the historical context, Ayton has finally made sense of the 1968 killing’ – Max Holland, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Kennedy Assassination Tapes")]), _vm._v(" and publisher of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington Decoded")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mel Ayton presents a compelling examination of the convicted [RFK] assassin’s motivations, his state of mind, and the mountain of evidence used to denounce and imprison him’ – Craig Hendricks, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The History Teacher")]), _vm._v(", Vol. 41, No. 2, February 2008")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have read some of your . . . articles about Sirhan’s many conspiracy theories, which demonstrate the wealth of your research as to the RFK murder.’ – California Deputy Attorney General Jaime Fuster, 13 December 2011")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mel Ayton [is] a writer I’ve found to be a valuable debunker of unwarranted conspiracy theorizing. He reminds us with copious quotations in [his articles] how repeatedly and explicitly Sirhan made clear why he targeted R.F.K.: because Sirhan hated the state of Israel and hated R.F.K.’s support for Israel.’ – Ron Rosenbaum, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Observer")]), _vm._v(", 20 November 2006")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Important and extensively documented. . . . especially pertinent to understanding current lone wolf terrorists, as it discusses leading forensic psychology theories to explain Sirhan’s possible mental state and motivations.’ – Joshua Sinai, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perspectives on Terrorism")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The 1968 assassination of Senator Robert Kennedy by Sirhan Sirhan may well be one of the most transforming events of the last third of the 20th century. . . . Mel Ayton documents the elements that contributed to Sirhan’s hatred of anyone or anything associated positively with Israel or Jews.’ – Harvard Professor Emeritus Alan Dershowitz, Foreword to the 2019 edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Forgotten Terrorist"), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31b44fa7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Praise.vue
// module id = 69
// module chunks = 0